import * as Html from "../util/Html.ts";
import TPL from "../form/giphy-preview.mustache";

Html.registerWidget('widget/giphy-preview',{initDom:initDom})

Html.registerDom({
  gifremove(){
    const preview = this.closest("[data-widget='widget/giphy-preview']");
    if(preview) preview.innerHTML = '';
  }
})

function initDom(node: HTMLElement){
  node.addEventListener('change', function(evt: Event){
    const customEvt = evt as CustomEvent;
    const data = customEvt.detail;
    if(data){
      node.style.display = '';
      Html.setHtml(node, TPL, data);
    }else{
      node.style.display = 'none';
      node.innerHTML = '';
    }
  });
}